export const dunzoreasons = [
    { index: 0, reason: "Raised order by mistake"},
    { index: 1, reason: "Partner refused to complete the order"},
    { index: 2, reason: "Partner is not moving"},
    { index: 3, reason: "Selected wrong delivery address"},
    { index: 4, reason: "Partner is taking too long to reach the pickup address"},
    { index: 5, reason: "Selected wrong pickup address"},
]